(function () {
    'use strict';

    angular.module('asys')
        .controller('ReiterPersoenlicheDatenController', ReiterPersoenlicheDatenController);

    ReiterPersoenlicheDatenController.$inject = [
        '$scope',
        '$log',
        'lodash',
        'AppConfig',
        'AngebotKfzService',
        'NavigationService',
        'BasisAngebotService',
        'MiscUtilsService',
        'HtmlUtilsService'
    ];
    function ReiterPersoenlicheDatenController($scope, $log, _, AppConfig, AngebotKfzService, NavigationService, BasisAngebotService, MiscUtilsService, HtmlUtilsService) {
        var vm = this,
            angebotVm = $scope.angebotVm,
            fahrzeughaltereigenschaften = BasisAngebotService.getConstant('fahrzeughaltereigenschaften', angebotVm.angebotModel.angebot),
            inkassoarten = BasisAngebotService.getConstant('inkassoarten'),
            partnerIcis = _.get(angebotVm.angebotModel.angebot, 'partnerIcis') || {};

        $log.debug('ReiterPersoenlicheDatenController', vm);

        vm.getFahrzeughalter = getFahrzeughalter;
        vm.isAbweichenderHalterErlaubt = isAbweichenderHalterErlaubt;

        activate();

        function activate() {
            MiscUtilsService.setDefaultValueIfEmpty(angebotVm.angebotModel.angebot, 'antragsteller.land', {
                typ: 'LAND',
                wert: 'D',
                bezeichnung: 'Deutschland'
            });

            vm.blockAntragstellerDatenOptions = {
                adresseDisabled: MiscUtilsService.isEverythingNotEmpty(partnerIcis.partnernummer, partnerIcis.postleitzahl, partnerIcis.strasse, partnerIcis.ort),
                disableAdresseSearchStrasse: false,
                cssClass: 'tag-form-control'
            };

            isFahrzeughalterPlzAbweichend();
            if ((
                    _.includes([
                        AppConfig.ANGEBOT.zahlweisen.VIERTELJAEHRLICH.wert,
                        AppConfig.ANGEBOT.zahlweisen.MONATLICH.wert
                    ], BasisAngebotService.getZahlweise(angebotVm.angebotModel.angebot).wert) &&
                    !BasisAngebotService.isRechnungBeiZahlweiseErlaubt(angebotVm.angebotModel.angebot)
                ) || (
                    _.get(angebotVm.angebotModel.angebot, 'zahlungsinformationen.rechnungAuswaehlbar') === false
                )
            ) {
                _.set(angebotVm.angebotModel.angebot, 'zahlungsinformationen.inkassoart', inkassoarten.abbucher.wert);
                angebotVm.CONSTANTS.listen.inkassoart = HtmlUtilsService.createSelectArray(inkassoarten.abbucher);
                NavigationService.setFollowingDisabled(true);

            } else {
                angebotVm.CONSTANTS.listen.inkassoart = HtmlUtilsService.createSelectArray(inkassoarten.abbucher, inkassoarten.rechnung);
            }

            $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                var cancleStateChange = false;

                if (NavigationService.isFollowing(toState.name)) {

                    if (isFahrzeughalterPlzAbweichend().status) {
                        cancleStateChange = true;
                    }

                    if (cancleStateChange) {
                        event.preventDefault();

                        if (vm.persDatenForm) {
                            if (vm.persDatenForm.submitInProgress) {
                                vm.persDatenForm.submitInProgress = false;
                            }

                            vm.persDatenForm.stateChangeCanceled = true;
                        }

                        return;
                    } else {
                        if (vm.persDatenForm) {
                            vm.persDatenForm.stateChangeCanceled = false;
                        }
                    }
                }
            });
        }
        function getFahrzeughalter() {
            var fahrzeughalter = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughalter'),
                postleitzahlFahrzeughalter = _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.postleitzahlFahrzeughalter');

            if (!AngebotKfzService.isFahrzeughalterReadOnly(angebotVm.angebotModel.angebot)) {
                _.set(fahrzeughalter, 'postleitzahl', postleitzahlFahrzeughalter);
            }

            return fahrzeughalter;
        }
        function isAbweichenderHalterErlaubt() {
            var vnFahrzeughaltereigenschaft = _.get(fahrzeughaltereigenschaften, 'versicherungsnehmer.wert');

            return (
                !angebotVm.isErsatzgeschaeft() &&
                _.get(angebotVm.angebotModel.angebot, 'angebotsgegenstandFahrzeug.fahrzeughaltereigenschaft.wert', vnFahrzeughaltereigenschaft) !== vnFahrzeughaltereigenschaft
            );
        }
        function isFahrzeughalterPlzAbweichend() {
            var fahrzeughalterVnPlzAntragstellerPlzAbweichend = AngebotKfzService.isFahrzeughalterPlzAbweichend(angebotVm.angebotModel.angebot, 'ANTRAG');

            if (fahrzeughalterVnPlzAntragstellerPlzAbweichend.status) {
                NavigationService.setFollowingDisabled(true);

                $scope.$emit('iplusjs:createAndAddAlert', {
                    message: AppConfig.MESSAGES.hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend[fahrzeughalterVnPlzAntragstellerPlzAbweichend.type],
                    type: 'alert',
                    id: 'hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend'
                });
            } else {
                $scope.$emit('iplusjs:removeAlert', {
                    id: 'hinweisFahrzeughalterVnPlzAntragstellerPlzAbweichend'
                });
            }

            return fahrzeughalterVnPlzAntragstellerPlzAbweichend;
        }
    }
})();
